import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const mockQuestions = [
  { id: 1, text: "What is the capital of France?", options: ["Berlin", "Madrid", "Paris", "Rome"] },
  { id: 2, text: "Which number is a prime number?", options: ["4", "6", "7", "9"] },
  { id: 3, text: "What is 10 × 5?", options: ["45", "50", "55", "60"] }
];

export function Exam() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [answers, setAnswers] = useState([]);
  const navigate = useNavigate();

  const handleNext = () => {
    const updatedAnswers = [...answers, { questionId: mockQuestions[currentIndex].id, selectedAnswer }];
    setAnswers(updatedAnswers);

    if (currentIndex < mockQuestions.length - 1) {
      setCurrentIndex(prev => prev + 1);
      setSelectedAnswer(null);
    } else {
      // TODO: POST to /api/exams/submit
      console.log("Exam submitted:", updatedAnswers);
      alert("Exam completed! Your results will be reviewed by your teacher.");
      navigate('/student/dashboard');
    }
  };

  const question = mockQuestions[currentIndex];
  const progress = ((currentIndex + 1) / mockQuestions.length) * 100;

  return (
    <div style={{ maxWidth: 650, margin: '40px auto', padding: 24, border: '1px solid #ddd', borderRadius: 10, background: '#fafafa' }}>
      <div style={{ height: 6, background: '#eee', borderRadius: 3, marginBottom: 20 }}>
        <div style={{ height: '100%', width: `${progress}%`, background: '#007BFF', borderRadius: 3, transition: 'width 0.3s' }} />
      </div>

      <h3 style={{ marginBottom: 8 }}>Question {currentIndex + 1} of {mockQuestions.length}</h3>
      <p style={{ fontSize: 18, marginBottom: 24, fontWeight: 500 }}>{question.text}</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
        {question.options.map((opt, idx) => (
          <label
            key={idx}
            style={{
              padding: 12,
              border: selectedAnswer === opt ? '2px solid #007BFF' : '1px solid #ccc',
              borderRadius: 8,
              cursor: 'pointer',
              background: selectedAnswer === opt ? '#e7f1ff' : '#fff'
            }}
          >
            <input
              type="radio"
              name="answer"
              value={opt}
              checked={selectedAnswer === opt}
              onChange={() => setSelectedAnswer(opt)}
              style={{ marginRight: 10 }}
            />
            {opt}
          </label>
        ))}
      </div>

      <button
        onClick={handleNext}
        disabled={!selectedAnswer}
        style={{
          width: '100%',
          padding: 14,
          background: selectedAnswer ? '#007BFF' : '#ccc',
          color: '#fff',
          border: 'none',
          borderRadius: 8,
          cursor: selectedAnswer ? 'pointer' : 'not-allowed',
          fontSize: 16,
          transition: 'background 0.2s'
        }}
      >
        {currentIndex < mockQuestions.length - 1 ? 'Next Question' : 'Finish Exam'}
      </button>
    </div>
  );
}

export default Exam;